import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { Grid } from '@material-ui/core';
import BulletList from 'Components/ComponentLibrary/Molecules/BulletList';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import { stepMap } from 'Views/Page/Content/Modal/Layouts/TotpRegistration/Layout';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const styles = (theme) => ({
  root: {},
  qrCode: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
  },
  stepTitle: {
    paddingBottom: theme.spacing(2),
  },
  secondaryButton: {
    marginTop: theme.spacing(1),
  },
});

const CaptureQRCode = ({
  className,
  classes,
  changeState,
}) => {
  const { resource } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        variant={'h4'}
        weight={'bold'}
        className={classes.stepTitle}
      >
        {'Open & Configure the App'}
      </Typography>
      <BulletList
        listItems={[
          'Open an authenticator app on your phone (like Google Authenticator, Authy, or Duo).',
          'Click to add a new account.',
          'Use the option to scan the barcode.',
          'Enter the code to access your Facet dashboard.',
        ]}
      />
      <Grid container justify={'center'} alignItems={'center'}>
        <Grid item className={classes.qrCode}>
          <img src={`data:image/png;base64, ${resource.attr('image')}`} test={'security-settings-authenticatorApp-register-modal-qrcode'} />
        </Grid>
      </Grid>
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Enter verification code');
            changeState(stepMap.enterVerificationCode);
          }}
        >
          {'Continue'}
        </RoundedButton>
        <TextButton
          className={classes.secondaryButton}
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Request backup code');
            changeState(stepMap.backupCode);
          }}
          test={'security-settings-button-authenticatorApp-register-modal-cant-scan'}
        >
          {'I can\'t scan the barcode'}
        </TextButton>
      </CenteredActions>
    </Box>
  );
};

CaptureQRCode.defaultProps = {
  className: '',
};

CaptureQRCode.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  changeState: PropTypes.func.isRequired,
};

export default withStyles(styles)(CaptureQRCode);
